import { ImSpinner4 } from "react-icons/im"

const Spinner = () => {
    return <ImSpinner4 className='w-6 text-white animate-spin' />
}

export default Spinner;